// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, react/prop-types */

import type { IControl } from "mapbox-gl";
import React, { createContext, createRef, useCallback, useContext, useReducer, useRef, useState } from "react";
import type MapboxDraw from "@mapbox/mapbox-gl-draw";

interface DrawState {
	// draw: (MapboxDraw & IControl) | null;
	drawnFeature: GeoJSON.Feature<any, any> | null;
}

interface DrawFunctions {
	updateDrawnFeature: (feature: GeoJSON.Feature<any, any> | null) => void;
	drawRef: React.RefObject<IControl & MapboxDraw>;
}

type DrawAction =
	| { type: "setup ref"; drawRef: IControl & MapboxDraw }
	| { type: "set drawn feature"; feature: GeoJSON.Feature<any, any> | null };

const drawReducer = (state: DrawState, action: DrawAction): DrawState => {
	switch (action.type) {
		case "set drawn feature":
			return { ...state, drawnFeature: action.feature };
		default:
			return state;
	}
};

const DrawContext = createContext<DrawState | null>(null);
const DrawDispatchContext = createContext<DrawFunctions | null>(null);
const drawRef = createRef<MapboxDraw & IControl>();

// @ts-expect-error -- TS7006: implicit any (legacy, TODO: add explicit types)
const DrawProvider = ({ children }) => {
	const [draw, dispatch] = useReducer(drawReducer, { drawnFeature: null });

	// const setupDrawRef = (drawRef: IControl & MapboxDraw) => dispatch({ type: "setup ref", drawRef });
	const updateDrawnFeature = useCallback(
		(feature: GeoJSON.Feature<any, any> | null) => dispatch({ type: "set drawn feature", feature }),
		[],
	);

	return (
		<DrawContext.Provider value={{ ...draw }}>
			<DrawDispatchContext.Provider value={{ drawRef, updateDrawnFeature }}>{children}</DrawDispatchContext.Provider>
		</DrawContext.Provider>
	);
};

const useDraw = () => {
	const context = useContext(DrawContext);

	if (context === null) {
		throw new Error("DrawContext is not provided");
	}

	return context;
};

const useDrawDispatch = () => {
	const context = useContext(DrawDispatchContext);

	if (context === null) {
		throw new Error("DrawDispatchContext is not provided");
	}

	return context;
};

export { DrawProvider, useDraw, useDrawDispatch };
